const PersonalizeStyle = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8327 4.99987L5.41753 6.0829C5.11504 6.1434 4.96379 6.17365 4.84062 6.24721C4.73173 6.31224 4.63912 6.40127 4.56985 6.50751C4.49149 6.62768 4.45529 6.77762 4.38291 7.07749L1.66602 18.3332M1.66602 18.3332L12.9217 15.6163C13.2216 15.5439 13.3715 15.5077 13.4917 15.4294C13.598 15.3601 13.687 15.2675 13.752 15.1586C13.8256 15.0354 13.8558 14.8842 13.9163 14.5817L14.9993 9.16654M1.66602 18.3332L7.98768 12.0115M17.3899 6.55707L13.4422 2.60935C13.1121 2.27934 12.9471 2.11433 12.7569 2.0525C12.5895 1.99812 12.4092 1.99812 12.2418 2.05251C12.0516 2.11433 11.8866 2.27934 11.5565 2.60935L10.9422 3.22373C10.6121 3.55375 10.4471 3.71875 10.3853 3.90903C10.3309 4.0764 10.3309 4.25669 10.3853 4.42406C10.4471 4.61433 10.6121 4.77934 10.9422 5.10935L14.8899 9.05707C15.2199 9.38708 15.3849 9.55209 15.5752 9.61391C15.7425 9.66829 15.9228 9.66829 16.0902 9.61391C16.2805 9.55209 16.4455 9.38708 16.7755 9.05706L17.3899 8.44268C17.7199 8.11267 17.8849 7.94766 17.9467 7.75739C18.0011 7.59002 18.0011 7.40973 17.9467 7.24236C17.8849 7.05209 17.7199 6.88708 17.3899 6.55707ZM9.16601 9.16654C10.0865 9.16654 10.8327 9.91273 10.8327 10.8332C10.8327 11.7537 10.0865 12.4999 9.16601 12.4999C8.24554 12.4999 7.49935 11.7537 7.49935 10.8332C7.49935 9.91273 8.24554 9.16654 9.16601 9.16654Z"
      stroke="#535862"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default PersonalizeStyle;
